export interface MessageError {
  readonly Message: string;
}

export function isMessageError(error: any): error is MessageError {
  return error && 'Message' in error;
}
